module.exports = __webpack_public_path__ + "static/media/pokeball-0.bec5897a.png";